import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = {
  key: 0,
  class: "pa-4"
}
const _hoisted_3 = { class: "d-flex align-start mb-4" }
const _hoisted_4 = { class: "pl-8 info-body" }
const _hoisted_5 = {
  key: 1,
  class: "pa-4"
}
const _hoisted_6 = { class: "d-flex align-start mb-4" }
const _hoisted_7 = { class: "pl-8 info-body" }
const _hoisted_8 = { class: "mt-6" }
const _hoisted_9 = {
  key: 0,
  class: "text-left"
}
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, { value: "各種利用料金" }),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
            key: 0,
            indeterminate: "",
            color: "primary",
            class: "ml-4",
            size: "24"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_spacer),
      (_ctx.invoiceStatus == null)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateInvoiceStatus('applied'))),
            color: "error",
            size: "large",
            variant: "flat",
            disabled: _ctx.isLoading
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode(" 確定 ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"]))
        : (_openBlock(), _createBlock(_component_v_btn, {
            key: 2,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateInvoiceStatus('canceled'))),
            color: "error",
            size: "large",
            variant: "outlined",
            disabled: _ctx.invoiceStatus != 'applied' || _ctx.isLoading
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" 確定取り消し ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"]))
    ]),
    _createVNode(_component_v_card, {
      variant: "flat",
      class: "mt-6 pa-2",
      color: "grey-lighten-5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _cache[7] || (_cache[7] = _createElementVNode("h5", null, "クラス", -1)),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.searchFilter.classId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFilter.classId) = $event)),
                      items: _ctx.formattedClasses,
                      "item-title": "displayTitle",
                      "item-value": "classId",
                      variant: "outlined",
                      "hide-details": "",
                      density: "compact",
                      clearable: "",
                      disabled: _ctx.isLoading
                    }, null, 8, ["modelValue", "items", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _cache[8] || (_cache[8] = _createElementVNode("h5", null, "年度", -1)),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.searchFilter.year,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchFilter.year) = $event)),
                      modelModifiers: { number: true },
                      suffix: "年度",
                      variant: "outlined",
                      "hide-details": "",
                      density: "compact",
                      type: "number",
                      disabled: _ctx.isLoading
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _cache[9] || (_cache[9] = _createElementVNode("h5", null, "月", -1)),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.searchFilter.month,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchFilter.month) = $event)),
                      items: _ctx.monthItems,
                      variant: "outlined",
                      density: "compact",
                      disabled: _ctx.isLoading
                    }, null, 8, ["modelValue", "items", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.invoiceStatus == null && _ctx.invoiceInfoPeriod.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              color: "error",
              class: "mr-2 mt-1"
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode("mdi-information", -1)
              ]))]),
              _: 1
            }),
            _cache[11] || (_cache[11] = _createElementVNode("h4", { class: "info-header ma-0" }, [
              _createTextVNode(" 認定期間が切れている園児がいます。"),
              _createElementVNode("br"),
              _createElementVNode("span", { class: "text-body-2 font-weight-regular" }, "認定情報設定より変更後確定を行ってください。")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "mb-2" }, "対象園児", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceInfoPeriod, (i, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, "・" + _toDisplayString(i), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.invoiceStatus == null && _ctx.invoiceInfoAge.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.invoiceInfoPeriod.length === 0)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  color: "error",
                  class: "mr-2 mt-1"
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("mdi-information", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("h4", {
              class: _normalizeClass(['info-header ma-0', { 'pl-8': _ctx.invoiceInfoPeriod.length > 0 }])
            }, " 3歳以上の園児が3号認定に設定されています。 ", 2)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mb-2" }, "対象園児", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceInfoAge, (i, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, "・" + _toDisplayString(i), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_v_table, null, {
        default: _withCtx(() => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _cache[15] || (_cache[15] = _createElementVNode("th", { class: "text-left" }, "氏名", -1)),
              _cache[16] || (_cache[16] = _createElementVNode("th", { class: "text-left" }, "年齢", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("th", { class: "text-left" }, "退園日", -1)),
              _cache[18] || (_cache[18] = _createElementVNode("th", { class: "text-left" }, "支払い方法", -1)),
              _cache[19] || (_cache[19] = _createElementVNode("th", { class: "text-left" }, "階層", -1)),
              _cache[20] || (_cache[20] = _createElementVNode("th", { class: "text-left" }, "保育必要量", -1)),
              _cache[21] || (_cache[21] = _createElementVNode("th", { class: "text-left" }, "保育料（基本料金）", -1)),
              _cache[22] || (_cache[22] = _createElementVNode("th", { class: "text-left" }, "延長料", -1)),
              _cache[23] || (_cache[23] = _createElementVNode("th", { class: "text-left" }, "園提供サービス", -1)),
              _cache[24] || (_cache[24] = _createElementVNode("th", { class: "text-left" }, "合計", -1)),
              (_ctx.isReadDateCol)
                ? (_openBlock(), _createElementBlock("th", _hoisted_9, "開封日"))
                : _createCommentVNode("", true),
              _cache[25] || (_cache[25] = _createElementVNode("th", null, null, -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceList, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.child.childId
              }, [
                _createElementVNode("td", null, _toDisplayString(item.child.lastName + item.child.firstName), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.getAgeFromBirthdate(item.child.dateOfBirth) + "歳"), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.child.quitDate)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.getPaymentMethodText(item.invoices[0]?.paymentMethod)), 1),
                _createElementVNode("td", null, _toDisplayString(item.invoices[0]?.rank || '-'), 1),
                _createElementVNode("td", null, _toDisplayString(item.invoices[0]?.childcareCategory
                  ? _ctx.childcareCategoryItems.find(
                      (v) => v.value == item.invoices[0].childcareCategory
                    )?.text || ""
                  : ""), 1),
                _createElementVNode("td", null, _toDisplayString((item.invoices[0]?.nurseryFee || 0) + "円"), 1),
                _createElementVNode("td", null, _toDisplayString((item.invoices[0]?.nurseryAdditionalFee || 0) + "円"), 1),
                _createElementVNode("td", null, _toDisplayString((item.invoices[0]?.nurseryServiceFee || 0) + "円"), 1),
                _createElementVNode("td", null, _toDisplayString((item.invoices[0]?.nurseryFee || 0) +
                (item.invoices[0]?.nurseryAdditionalFee || 0) +
                (item.invoices[0]?.nurseryServiceFee || 0) +
                "円"), 1),
                (_ctx.isReadDateCol)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(item.invoices[0]?.readDate ? _ctx.datetimeConv(item.invoices[0].readDate) : ""), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, [
                  _createVNode(_component_v_btn, {
                    onClick: ($event: any) => (_ctx.clickDetail(item)),
                    disabled: _ctx.isLoading,
                    color: "primary",
                    variant: "flat",
                    size: "small"
                  }, {
                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                      _createTextVNode("詳細", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}